import { createSelector } from 'reselect';
import { Action, Reducer } from 'redux';

import * as actionTypes from 'constants/Payments';
import { PaymentType } from 'types/PaymentType';

import { getSetting } from './configs/settings';

// TODO: finish transition to typescript:
// * add types to reducers
// * add types to selectors

const initialState: PaymentType[] = [];

const paymentTypes: Reducer<
  PaymentType[],
  Action & { payload: PaymentType[] }
> = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_PAYMENT_TYPES:
      return payload;
    default:
      return state;
  }
};

export default paymentTypes;

const baseTypes = [
  'TRANSFER',
  'CASH',
  'CREDIT',
  'GIFTCARD',
  'TIP',
  'CHECK',
  'CARD',
];

export const getAllPaymentTypes = (state): PaymentType[] => state.PaymentTypes;
export const getCustomPaymentTypes = createSelector(
  state => getAllPaymentTypes(state),
  paymentTypes =>
    paymentTypes.filter(paymentType => !baseTypes.includes(paymentType.type)),
);
export const getIdForCustomPaymentType = type => state =>
  getCustomPaymentTypes(state).find(pt => pt.type === type)?.id;

export const getEnabledCustomPaymentsSetting = createSelector(
  state => getSetting('enabled_custom_payments', '{}')(state),
  setting => {
    try {
      return JSON.parse(setting);
    } catch (e) {
      return {};
    }
  },
);
const getActiveCustomPayments = createSelector(
  state => getCustomPaymentTypes(state),
  state => getEnabledCustomPaymentsSetting(state),
  (customPts, enabledSettings) =>
    customPts.filter(pt => enabledSettings[pt.type]),
);

export const getExternalPayments = createSelector(
  state => getSetting('pos_external_extra_card_payment_types', '')(state),
  (listString: string) =>
    listString
      .split(',')
      .map(a => a.trim())
      .filter(a => a.length),
);

const getCustomCardTypesSetting = createSelector(
  state => getSetting('pos_custom_extra_card_payment_types', '')(state),
  listString => listString.split(','),
);
export const getPaymentCards = createSelector(
  state => getCustomPaymentTypes(state),
  state => getCustomCardTypesSetting(state),
  (customPts, enabledSettings) => {
    return customPts.filter(pt => 0 <= enabledSettings.indexOf(pt.name));
  },
);

export const getActiveCustomPaymentNames = state =>
  getActiveCustomPayments(state).map(a => a.name);
export const getActiveCustomPaymentTypes = state =>
  getActiveCustomPayments(state).map(a => a.type);

interface CustomPaymentConfig {
  [paymentType: string]: {
    askForReferenceNumber: boolean;
    referenceNumberLabel?: string;
  };
}

export const getCustomPaymentConfig = createSelector(
  state => getSetting('custom_payment_configuration', '{}')(state),
  setting => {
    try {
      return JSON.parse(setting) as CustomPaymentConfig;
    } catch (e) {
      return {} as CustomPaymentConfig;
    }
  },
);
